import React from 'react';
import ReactPlayer from 'react-player-fork';
// import ReactPlayer from '../../../../../react-player';
import { utils } from '../../utils';

class FullscreenVideo extends React.Component {
  constructor(props) {
    super(props);

    this.handleArrowKeys = this.handleArrowKeys.bind(this);

    this.state = {
      buffering: false,
      duration: 0,
      volume: 0.8,
      playing: true,
      played: 0,
      loaded: 0,
      mute: false
    }
  }

  clickOffset(e) {
    const element = e.currentTarget;
    const clickOffsetInElement = e.pageX - $(element).offset().left;
    const elementWidth = element.getBoundingClientRect().width;
    return clickOffsetInElement / elementWidth;
  }

  seekTo(e) {
    const played = this.clickOffset(e);
    this.video.seekTo(played);
    this.setState({played});
  }

  changeVideoLocation(diff) {
    const played = this.state.played + diff;
    this.video.seekTo(played);
    this.setState({played});
  }

  setVolume(e) {
    this.setState({volume: this.clickOffset(e), mute: false});
  }

  changeVolume(diff) {
    this.setState({volume: this.state.volume + diff, mute: false});
  }

  togglePlay() {
    if (this.isUnplayedExternalMobileVideo()) {
      this.setState({playing: false, playedOnce: true});
    } else {
      this.state.playing ? this.pause() : this.play();
    }
  }

  isUnplayedExternalMobileVideo() {
    return this.isExternalMobileVideo() && !this.state.playedOnce;
  }

  isPlayedExternalMobileVideo() {
    return this.isExternalMobileVideo() && this.state.playedOnce;
  }

  isExternalMobileVideo() {
    return utils.isMobile() && !this.props.isDummy && this.props.item.metadata.isExternal;
  }

  secondsToTimeString(seconds) {
    if (!(seconds >= 0)) { //could also be NaN
      seconds = 0;
    }
    const hourFixer = seconds >= 3600 ? 3 : 0;
    return new Date(seconds * 1000).toISOString().substr(14 + hourFixer, 5 + hourFixer);
  }

  onProgress({loaded, played}) {
    this.setState({loaded, played});
  }

  play() {
    this.setState({playing: true, playedOnce: true});
  }

  pause() {
    this.setState({playing: false});
  }

  autoPlay() {
    if (this.props.isDisplayed && !utils.isMobile()) {
      this.play();
    } else if (!this.props.isDummy) {
      this.pause();
    }
  }

  handleArrowKeys(e) {

    if (!utils.isAccessibilityEnabled() || !this.props.isDisplayed) {
      //the keypress events are only effective when the video is displayed
      return true;
    }

    let activeControl = null;
    const activeControlClassName = document.activeElement.className || '';
    if (activeControlClassName.indexOf('fullscreen-video-controls-progress') >= 0) {
      activeControl = 'progressBar'
    } else if (activeControlClassName.indexOf('fullscreen-video-controls-volume-bar') >= 0) {
      activeControl = 'volumeBar'
    }

    switch (e.keyCode || e.charCode) {
      case 38: //up
        if (activeControl === 'volumeBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVolume(0.1);
        }
        return false;
      case 40: //down
        if (activeControl === 'volumeBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVolume(-0.1);
        }
        return false;
      case 37: //left
        if (activeControl === 'progressBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVideoLocation(-0.1);
        }
        return false;
      case 39: //right
        if (activeControl === 'progressBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVideoLocation(0.1);
        }
        return false;
    }

    return true;
  }


  stopPropagation(event) {
    event.stopPropagation();
  }

  componentWillUnmount() {
    if (this.video.stopBuffering) {
      this.video.stopBuffering();
    }
  }

  componentDidMount() {
    console.log('Video Did Mount');
    this.autoPlay();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isDisplayed != this.props.isDisplayed) {
      console.log('Video Did Update');
      this.autoPlay();
    }
  }

  onWrapperClick() {
    if (utils.isMobile() && !this.props.isDummy && !this.state.playedOnce) {
      this.setState({playedOnce: true});
    }
  }

  render() {


    const {playing, volume, played, buffering, mute, duration} = this.state;
    const {item, isDummy, isDisplayed, window} = this.props;

    const transform = 'translate3d(-50%, -50%, 0) scale(' + window.scale.min(item) + ')';
    const innerStyle = {
      'width': item.width + 'px',
      'height': item.height + 'px',
      'transform': transform,
      'WebkitTransform': transform,
      'MozTransform': transform,
      'msTransform': transform,
      'OTransform': transform
    };

    var videoControls = (
      <div className={"fullscreen-video-controls " + (utils.isMobile() ? 'mobile' : '')} style={innerStyle}>
        <div onClick={this.togglePlay.bind(this)}  className="fullscreen-video-controls-wrapper">
          <div className="fullscreen-video-controls-bar" onClick={this.stopPropagation}>
            <button
              className={"cursor-pointer fullscreen-video-controls-play " + (buffering ? 'fa fa-circle-o-notch fa-spin' : (playing ? 'progallery-svg-font-icons-pause' : 'progallery-svg-font-icons-play'))}
              onClick={this.togglePlay.bind(this)}
              tabIndex={isDisplayed ? utils.getTabIndex('fullscreenVideoPlay') : -1}
              aria-label="Play, toggle"
            />
            <div className="cursor-pointer fullscreen-video-controls-progress" onClick={this.seekTo.bind(this)}
                 tabIndex={isDisplayed ? utils.getTabIndex('fullscreenVideoBar') : -1}
                 aria-label={`Video Progress Bar, (${(Math.round(played * 10) * 10) + '%'})`}
                 aria-live="polite"
                 onKeyDown={this.handleArrowKeys}
                 role="progressbar"
            >
              <div className="fullscreen-video-controls-progress fill" style={{width : played * 100 + '%'}}/>
            </div>
            <span className="fullscreen-video-controls-time">{this.secondsToTimeString(duration * played)}</span>
            <span className="fullscreen-video-controls-slash">/</span>
            <span className="fullscreen-video-controls-time">{this.secondsToTimeString(duration)}</span>
            <button className={"cursor-pointer fullscreen-video-controls-volume-icon progallery-svg-font-icons-volume"}
                   onClick={() => {this.setState({mute: !mute})}}
                   tabIndex={isDisplayed ? utils.getTabIndex('fullscreenVideoMute') : -1}
                   aria-label={`${this.state.mute ? 'Unmute' : 'Mute'}`}
            />
            <div className="cursor-pointer fullscreen-video-controls-volume-bar" onClick={this.setVolume.bind(this)}
                 tabIndex={isDisplayed ? utils.getTabIndex('fullscreenVideoVolume') : -1}
                 aria-label="Volume Controller"
                 aria-live="polite"
                 onKeyDown={this.handleArrowKeys}
                 role="progressbar"
            >
              <div className="fullscreen-video-controls-volume-bar fill" style={{width: (mute ? 0 : volume * 100) + '%'}}/>
            </div>
          </div>
        </div>
      </div>
    );
    var videoOverlay = this.isPlayedExternalMobileVideo() ? (
      <div className="fullscreen-mobile-external-video-overlay"
           style={{height: item.height * 0.7, width: item.width}}
           onTouchEnd={() => this.togglePlay()}></div>
    ) : '';

    let isMobileExternalVideoPlayed = (item.metadata.isExternal && this.state.playedOnce && utils.isMobile());

    return (!isDummy) ? (
      <div>
        <div
          data-hook="fullscreen-video"
          className={'fullscreen-item fullscreen-item-video fullscreen-item-' + item.idx + (utils.isiOS() ? ' ios' : '')}
          key={'video_container'}

        >
          <ReactPlayer
            url={item.videoUrl ? item.videoUrl : item.resized_url['mp4']}
            loop={!!this.props.styleParams.videoLoop}
            width={item.width}
            height={item.height}
            className={'fullscreen-video fullscreen-video-' + item.idx}
            style={innerStyle}
            ref={video => { this.video = video }}
            playing={isDisplayed && playing}
            volume={mute ? 0 : volume}
            onReady={() => console.log('fullscreen video onReady itemId: ' + item.idx)} //checking the only the correct video is loading
            onStart={() => console.log('fullscreen video onStart itemId: ' + item.idx)}
            onPlay={() => this.setState({playing: true})}
            onPause={() => this.setState({playing: false})}
            onBuffer={buffering => this.setState({buffering})}
            onEnded={() => !!this.props.styleParams.videoLoop || this.setState({playing: false})}
            onError={e => console.log('onError', e)}
            onProgress={({loaded, played}) => this.setState({loaded, played})}
            onDuration={duration => this.setState({duration})}
            poster={item.resized_url['img']}
            onWrapperClick={this.onWrapperClick.bind(this)}
            mockPlayer={false}
            playbackRate={this.props.styleParams.videoSpeed || 1}
            fileConfig={{
              attributes: {
                poster: item.resized_url['img'],
              },
            }}
            controls={item.metadata.isExternal || utils.isiOS()}
          />
          {this.isPlayedExternalMobileVideo() || playing ? '' : (
            <div onClick={this.togglePlay.bind(this)}>
              <i className={"cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-triangle  " + (item.metadata.isExternal ? ' external' : '')}/>
              <i className={"cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-background " + (item.metadata.isExternal ? ' external' : '')}/>
            </div>
          )}
          {item.metadata.isExternal ? videoOverlay : videoControls}
        </div>
    </div>
    ) : ( //slides on the left or right
      <div>
        <video preload="none"
              width={item.width} height={item.height}
              poster={item.resized_url['img']}
              className={'fullscreen-item fullscreen-video-' + this.props.item.idx}
              key={'video'}
              style={innerStyle}
              ref={video => { this.video = video }}
        >
          <source src={item.resized_url['mp4']} type="video/mp4"/>
          <source src={item.resized_url['webm']} type="video/webm"/>
        </video>
      </div>
    );

  }
}
export default FullscreenVideo;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenVideo.js